export const RestrictionType = {
  COUNTRY: "country",
  AREA: "area",
  DISTANCE: "distance",
} as const;

export type RestrictionType =
  typeof RestrictionType[keyof typeof RestrictionType];
